import {
    ViewMode,
} from '../constants';

import {
    CREDIT_ORDER_RECEIVE,
    CREDIT_ORDER_ERROR,
    CREDIT_ORDER_CHANGE_MODE,
    CREDIT_ORDER_CHANGE_CURRENTPAGE,
    CREDIT_ORDER_SET_ORDER
} from '../ConstantsBrafab/constants';

import { error as errorReducer } from '../Reducers/Error.reducer';

const defaultState = {
    mode: ViewMode.List,
    list: [],
    order: {},
    totalCount: 0,
    showOnlyMyOrders: false,
    errors: {},
};

export const creditOrder = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CREDIT_ORDER_RECEIVE:
        case CREDIT_ORDER_CHANGE_MODE:
        case CREDIT_ORDER_CHANGE_CURRENTPAGE:
        case CREDIT_ORDER_SET_ORDER:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case CREDIT_ORDER_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};